module.exports = __webpack_public_path__ + "img/joan.4771e75.webp";